import * as React from 'react';
import { Card } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import ClaimsProgressBar from '../ClaimHistoryComponents/ClaimsProgressBar';
import { getNextStep, getOverview } from '../../../../actions/claimHistoryActionsV2'
import { CLAIM_HISTORY_V2 } from '../../../../routes/routes';
import { HashLink as Link } from 'react-router-hash-link';
import ClaimsNextStep from '../ClaimHistoryComponents/ClaimsNextStep';

class Towing extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.getFormatAssesmentDate = this.getFormatAssesmentDate.bind(this);
    }

    async handleClick() {
        this.props.handleGetNextStep();

    }

    async handleBackClick() {
        this.props.handleClaimsBackClick();
    }

    getFormatAssesmentDate(date: string) {
        if (date) {
            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var stringDate = date.split('T')[0];
            var formatedDate = new Date(stringDate);
            var fullFormatedDate = formatedDate.getDate().toString() + " " + monthNames[formatedDate.getMonth()] + " " + formatedDate.getFullYear().toString();
            return fullFormatedDate;
        }
        return "Not Found";
    }

    render() {
        const scrollWithOffset = (el) => {
            const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
            const yOffset = -90;
            window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
        }
        const stepsList = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.overallEstProgressBar !== null).length > 0
        let nrToUse = -1
        if (this.props.claimSubmit.claimProgress) {
            for (var i = 0; i < this.props.claimSubmit.claimProgress.claimSteps.length - 1; i++) {
                if (this.props.claimSubmit.claimProgress.claimSteps[i + 1].claimStepDescription.toLowerCase() !== this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase()) {
                    nrToUse += 1
                    if (this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase() === this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase()) {
                        break;
                    }
                }
            }
        }
        const claimStepDescription = this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase();
        const claimStep = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() === claimStepDescription)[0];
        return (
            <>
                <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                <div id="Towing">
                    {stepsList && !this.props.claimSubmit.selectedClaimProgressStep.isComplete && claimStepDescription && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) &&
                        <Card className="content-box-padding-20px-with-box-shadow mb-15px">
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <ClaimsProgressBar />
                                </div>
                            </div>
                        </Card>
                    }
                    <Card className="mt-3 content-box-padding-20px-with-box-shadow">
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="claims-noc-step-header-icon-area">
                                        {
                                            (!this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                            <>
                                                <img src={"/my-policy/Images/Claims/Numbers/" + nrToUse + "-red.png"} alt={"Step " + nrToUse} title={"Step" + nrToUse} />
                                            </>
                                        }
                                        {
                                            (this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                            <>
                                                <img alt="Step 3: Completed" title="Step 3: Completed" src="/my-policy/Images/Claims/Numbers/step-success-32x32px.svg" />
                                            </>
                                        }
                                    </div>
                                    <div className="col nopa claims-noc-step-header-title-area">
                                        <h3>Towing</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 nopa mt-10px">
                                <div className="font-weight-500 mb-0px">

                                    {
                                        (this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                        <>
                                            Towing = done. You can have a look at the next step.
                                        </>
                                    }
                                    {
                                        (!this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                        <>
                                            Ready, set... Tow! Here's some info on your car's towing progress.
                                            {!isMobile &&
                                                <>
                                                    <br /><br />
                                                    <span>Scroll down to the<Link className="text-red" to={CLAIM_HISTORY_V2 + "#claimFAQ"} scroll={el => scrollWithOffset(el)}> <b className="text-underline">FAQ’s</b></Link> for more info.</span>
                                                </>
                                            }
                                            {isMobile &&
                                                <>
                                                    <br /><br />
                                                    <span>Scroll down to the<Link className="text-red"> <b>FAQ’s</b></Link> for more info.</span>
                                                </>
                                            }
                                        </>
                                    }
                                </div>
                                <hr className="mt-18px mb-15px claims-v2-hr-2px" />
                            </div>
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="col-12 nopa">
                                        <p className="card-subheading mb-0px">Where we’re at</p>
                                    </div>
                                    <div className="mt-10px">
                                        {
                                            (this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                            <>
                                                <p className={this.props.claimSubmit.selectedClaimProgressStep.claimTowingStep.assessmentCentre ? "text-16 text-red mb-15px" : "text-16 text-red mb-0px"}>Your car’s been towed (yass)</p>
                                                {this.props.claimSubmit.selectedClaimProgressStep.claimTowingStep?.assessmentCentre &&
                                                    <p className="font-weight-500 mb-0px">
                                                        *Happy dance*
                                                    <br />
                                                   Your {this.props.claimSubmit.selectedClaim.riskItemType.toLowerCase()}'s at our approved assessment centre, {this.props.claimSubmit.selectedClaimProgressStep.claimTowingStep?.assessmentCentre}, and we'll assess its damage ASAP
                                                </p>
                                                }
                                            </>
                                        }
                                        {
                                            (!this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                            <>
                                                <p className="text-16 text-red mb-15px">We’ve arranged for your car to be towed</p>
                                                {(this.props.claimSubmit.selectedClaimProgressStep.claimTowingStep.towingAuthorisation === "Authorised – Assist Line Contacted") && <p className="font-weight-500 mb-0px">Good news! We just need to confirm that your car is at 1 of our approved assessment centres</p>}
                                                {(this.props.claimSubmit.selectedClaimProgressStep.claimTowingStep.towingAuthorisation === "N/A – Vehicle not towed") && <p className="font-weight-500 mb-0px">Good news! Your car should reach 1 of our approved assessment centres soon</p>}
                                                {(this.props.claimSubmit.selectedClaimProgressStep.claimTowingStep.towingAuthorisation === "Unauthorised – Assist Line Not Contacted") && <p className="font-weight-500 mb-0px">Good news! Your car should reach 1 of our approved assessment centres soon. If it wasn’t towed by an approved towing service provider, we may need to pay some fees and move your car first. In this case, it might take a teensy bit longer. But, we’re on it (promise)</p>}
                                            </>
                                        }
                                    </div>
                                </div>
                                <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                            </div>
                            {this.props.claimSubmit.selectedClaimProgressStep.claimTowingStep.towingDate &&
                                (!this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className={!isMobile ? "col nopa" : "col-12 nopa"}>
                                            <p className="card-subheading mb-0px"> Date arranged</p>
                                        </div>
                                        <div className={!isMobile ? "" : "col-12 nopa mt-10px"}>
                                            <p className="text-red text-lg-right mb-0px">{this.getFormatAssesmentDate(this.props.claimSubmit.selectedClaimProgressStep.claimTowingStep.towingDate)}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa">
                                        <p className="next-step-subheading mb-0">Next step</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <ClaimsNextStep />
                            </div>
                        </div>
                    </Card>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
        handleClaimsBackClick: () => dispatch(getOverview()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Towing);
